import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import FeaturedCampaigns from '../components/home/FeaturedCampaigns';
import HowItWorks from '../components/home/HowItWorks';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/home/CTASection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import ZeroFeeBanner from '../components/home/ZeroFeeBanner';
import RecommendedSection from '../components/recommendations/RecommendedSection';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <ZeroFeeBanner />
        <RecommendedSection variant="home" limit={6} />
        <FeaturedCampaigns />
        <WhyChooseUs />
        <HowItWorks />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
